import {
  Button,
  Card,
  CardActions,
  CardContent,
  Grid
} from '@mui/material';
import { AppConfig } from 'AppConfig';
import axios from 'axios';
import 'common/bstCard/bstCard.css';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { LOAD_DATA } from 'reducers/reducersConstants';
import { store } from 'store/store';
import { hasPermission } from 'utils/common';
import LocalStore from 'utils/LocalStore';
import ReportCard from './reportCard';
import ReportCardItem from './ReportCardItem';
import SmartCard from './smartCard';


const BstCard = (props) => {
  const navigate = useNavigate();

  const renderItem = (props) => {
    const reportType = props?.type;

    if (reportType === AppConfig.SMART_CAROUSEL) {
      return (
        <SmartCard
          item={props.item}
          showDismiss={
            hasPermission(
              AppConfig.PERMISSION.FO_SMARTCARD_DISMISS,
              props.permissions
            )
          }
          reportType={reportType}
          viewMode={props.viewMode}
        />
      );
    } else if (reportType === AppConfig.OFTENTIMES_CAROUSEL) {
      return (
        <ReportCard
          item={props.item}
          showFavorite={false}
          showDismiss={false}
          reportType={reportType}
        />
      );
    } else if (reportType === AppConfig.SHARE_CAROUSEL) {
      return (
        <Card style={{ height: props.h }}>
          <CardContent>
            <div width={props.width} height={props.height}>
              <Grid>
                <Grid center>
                  <span
                    style={{
                      fontWeight: 'bold',
                      fontSize: '12px',
                      marginBottom: '5px'
                    }}>
                    {props.item.displayText}

                    <Button
                      onClick={() => {
                        axios
                          .post(
                            AppConfig.FO_INITIAL_URL + '/init/shareReject',
                            {
                              reptSource: props.item.reptSource,
                              shareBy: props.item.sharedBy
                            },
                            {
                              headers: {
                                Authorization:
                                  'Bearer ' + LocalStore.getAccessToken()
                              }
                            }
                          )
                          .then((res) => {
                            axios
                              .post(
                                AppConfig.FO_INITIAL_URL +
                                AppConfig.USER_PROFILE_PATH,
                                {
                                  username: props.username,
                                  app: AppConfig.APP_FO,
                                  updateCache: 'true'
                                }
                              )
                              .then(
                                (res) => {
                                  if (res && res.data) {
                                    store.dispatch({
                                      type: LOAD_DATA,
                                      payload: res.data
                                    });
                                  }
                                },
                                (err) => {
                                  console.log(err);
                                }
                              );
                          })
                          .catch((err) => {
                            console.log(err);
                          });
                      }}>
                      Reject
                    </Button>
                  </span>
                </Grid>
                <Grid>By: {props.item.sharedBy}</Grid>
              </Grid>
              <Grid>
                <span
                  style={{
                    marginTop: '5px',
                    marginBottom: '5px',
                    fontFamily: 'OpenSans-Regular',
                    fontSize: '12px',
                    padding: '10px'
                  }}>
                  {props.item.description}
                </span>
              </Grid>
              <Grid
                center
                style={{
                  position: 'absolute',
                  bottom: '0',
                  marginBottom: '10px'
                }}></Grid>
            </div>
          </CardContent>
          <CardActions>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => {
                navigate('/report/chart', {
                  path: window.location.pathname,
                  src: props.item,
                  state: { category: props.item.category }
                });
              }}>
              View Report
            </Button>
          </CardActions>
        </Card>
      );
    } else {
      return (
        <ReportCardItem
          item={props.item}
          reportType={reportType}
          viewMode={props.viewMode}
        />
      );
    }
  };

  return (
    <div className="carousel-cell__inner" style={{ width: props.w }}>
      {renderItem(props)}
    </div>
  );
};

const mapStateToPropsSelector = (state) => ({
  username: state.user.username,
  currentTenantCd: state.user.currentTenantCd,
  permissions: state.user.permissions
});

export default connect(mapStateToPropsSelector)(BstCard);
